import { useTenant } from "../contexts/TenantContext";
import { Subheading } from "../design/heading";
import { Text } from "../design/text";

export default function ContactUsFooter() {
  const { tenant } = useTenant();
  if (!tenant) return null;
  if (!tenant.phoneNumber) return null;
  return (
    <div className="mt-4 text-center">
      <Text>Or</Text>
      <Subheading>{`Feel free to call us at ${tenant.phoneNumber}`}</Subheading>
    </div>
  );
}
